module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "btn-group btn-group-justified new-switch-group"
  }, _vm._l((_vm.options), function(option, index) {
    return _c('label', {
      key: index,
      staticClass: "btn-group new-switch-label pointer",
      class: [_vm.selectedValue === option.value ? 'new-switch-active' : ''],
      attrs: {
        "id": 'opt' + option.value,
        "name": _vm.name
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedValue),
        expression: "selectedValue"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": option.value,
        "checked": _vm._q(_vm.selectedValue, option.value)
      },
      on: {
        "click": _vm.updateValue,
        "change": function($event) {
          _vm.selectedValue = option.value
        }
      }
    }), _vm._v("\n      " + _vm._s(option.name) + "\n    ")])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f73165b8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/inputs/InputSwitch.vue
// module id = 681
// module chunks = 5